import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { $messageCentreStore, $paymentByIdStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { BaseInput, Button, CustomFile, ErrorMessage, FileUpload, Modal, Text } from '@shared/widgets';

interface IForm {
  reference: string;
  attachment: Blob | null;
}
const DEFAULT_VALUES: IForm = { reference: '', attachment: null };

interface DisputeTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DisputeTransactionModal = (props: DisputeTransactionModalProps) => {
  const { navigate } = useRouteHook();

  const paymentStore = useUnit($paymentByIdStore.store);

  const { control, formState, handleSubmit, reset } = useForm<IForm>({
    defaultValues: { ...DEFAULT_VALUES, reference: paymentStore.data?.referenceNumber || '' },
  });

  const { t } = useTranslation();

  const closeHandler = () => {
    props.onClose();
    reset({ ...DEFAULT_VALUES, reference: paymentStore.data?.referenceNumber || '' });
  };
  const submitHandler = async (data: IForm) => {
    const formData = new FormData();
    data.attachment && formData.append('file', data.attachment);

    $messageCentreStore.events.createNewThreadWithMessage({
      subject: 'Dispute Transaction',
      body: data.reference,
      file: data.attachment ? formData : undefined,
    });

    paymentStore.data?.referenceNumber && navigate(RoutePaths.messages.onNavigate());
    closeHandler();
  };
  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} title='Dispute Transaction' width='380px'>
      <form className='flex flex-col gap-2' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Text>Please provide transaction reference number to dispute transaction</Text>
        <Controller
          name='reference'
          control={control}
          rules={{ required: t('errors.form.required', { ns: 'common' }) }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <BaseInput
                {...field}
                label='Reference number'
                placeholder='Reference number'
                required
                readOnly={!!paymentStore.data?.referenceNumber}
              />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Controller
          name='attachment'
          control={control}
          render={({ field: { value, onChange } }) => (
            <FileUpload label='Attachment' value={value as unknown as CustomFile} onChange={onChange} onDelete={() => onChange(null)} />
          )}
        />
        <Button className='mt-6' color='primary' type='submit' disabled={formState.isSubmitting}>
          Submit
        </Button>
      </form>
    </Modal>
  );
};
